import { useCallback } from 'react';
import { translations } from '../translations';

export const useTranslation = () => {
  const currentLanguage = localStorage.getItem('language') || 'EN';

  const t = useCallback(
    (key) => {
      return translations[currentLanguage]?.[key] || translations['EN'][key];
    },
    [currentLanguage]
  );

  return { t, currentLanguage };
};
